import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RequireAuth from "../utils/RequireAuth";
import RedirectIfLoggedIn from "../utils/RedirectIfLoggedIn";
// unprotectedRoutes
import { auth_routes } from "./UnProtectedRoutes";
// protectedRoutes
import { admin_routes } from "./AdminRoutes";
import { general_routes } from "./GeneralRoutes";
import Nav from "../components/Nav";
import { superAdmin_routes } from "./SuperAdminRoutes";

const AppRoutes = () => {
    const protectedRoutes = [
        ...admin_routes,
        ...superAdmin_routes,
        ...general_routes
    ];

    const unprotectedRoutes = [...auth_routes];

    return (
        <BrowserRouter>
            <div className="outer-container">
                <Nav></Nav>
                <div className="content-container">
                    <Routes>
                        {
                            unprotectedRoutes.map((e) => {
                                return (
                                    <Route
                                        key={e.path}
                                        exact
                                        path={e.path}
                                        element={
                                            <RedirectIfLoggedIn>
                                                {e.ele}
                                            </RedirectIfLoggedIn>
                                        }
                                    // element={e.ele}
                                    />
                                );
                            })
                        }

                        {
                            protectedRoutes.map((e) => {
                                return (
                                    <Route
                                        key={e.path}
                                        exact
                                        path={e.path}
                                        element={
                                            <RequireAuth userroles={e?.availability}>
                                                {e.ele}
                                            </RequireAuth>
                                        }
                                    // element={e.ele}
                                    />
                                );
                            })
                        }
                    </Routes>
                </div>
            </div>
        </BrowserRouter>
    );
};
export default AppRoutes;